import { Controller } from "@hotwired/stimulus";

declare global {
  interface WindowEventMap {
    dispatchOverlayToggle: CustomEvent;
  }
}

export default class DispatchOverlayController extends Controller {
  toggle() {
    window.dispatchEvent(new CustomEvent("dispatchOverlayToggle"));
  }
}
